import { createElement } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { App, type AppProps } from '../components/App';
import './styles.css';

const ROOT_ID = 'blink-effect-podlet-root';
const CONFIG_ID = 'blink-effect-podlet-config';

const shadowRoot = document.querySelector('blink-effect-podlet')?.shadowRoot;

if (shadowRoot) {
    const stylesheets = [
        'https://assets.finn.no/pkg/@warp-ds/css/v2/components.css',
        'https://assets.finn.no/pkg/@warp-ds/css/v2/tokens/finn-no.css',
        'https://assets.finn.no/pkg/@warp-ds/fonts/v1/finn-no.css',
        'https://assets.finn.no/pkg/@warp-ds/css/v2/resets.css',
    ];
    for (const href of stylesheets) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        shadowRoot.appendChild(link);
    }
}

const root = shadowRoot?.getElementById(ROOT_ID) ?? document.getElementById(ROOT_ID);
const configElement = shadowRoot?.getElementById(CONFIG_ID) ?? document.getElementById(CONFIG_ID);

if (root && configElement?.textContent) {
    const props = JSON.parse(configElement.textContent) as AppProps;
    hydrateRoot(root, createElement(App, props));
}
